<template>
  <el-dialog
    :title="$t('CampaignForm_TestSendDialog_Title')"
    :visible="dialogVisible"
    width="600px"
    :before-close="close"
    :append-to-body="true"
  >
    <el-row>
      <el-col>
        <form-item
          :disabled="disableInput"
          prop="email_subject"
          :label="$t('CampaignForm_Email_Field_Subject')"
        >
          <el-input v-model="data.email_subject" />
        </form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <form-item
          :disabled="disableInput"
          prop="email_from_address"
          :label="$t('CampaignForm_Email_Field_Address')"
        >
          <el-autocomplete
            popper-class="autocomplete-list"
            autocomplete="no"
            v-model="data.email_from_address"
            :fetch-suggestions="querySearchFromAddr"
            @select="handleFromAddr"
          >
            <template slot-scope="{ item }">
              <div>{{ item.value }}</div>
              <div class="desc">{{ item.description }}</div>
            </template>
          </el-autocomplete>
        </form-item>
      </el-col>
      <el-col :span="12">
        <form-item
          :disabled="disableInput"
          prop="email_from_name"
          :label="$t('CampaignForm_Email_Field_Name')"
        >
          <el-input v-model="data.email_from_name" />
        </form-item>
      </el-col>
      <el-col>
        <form-item
          :disabled="disableInput"
          prop="recipient_emails"
          :label="$t('CampaignForm_Email_Field_RecipientEmails')"
        >
          <el-select
            v-model="recipient_emails"
            :multiple-limit="10"
            multiple
            filterable
            allow-create
            default-first-option
          >
            <el-option
              v-for="item in options"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </form-item>
      </el-col>
      <el-col>
        <form-item
          :disabled="disableInput"
          prop="render_profile_email"
          :label="$t('CampaignForm_Email_Field_RenderProfile')"
        >
          <el-autocomplete
            popper-class="autocomplete-list"
            autocomplete="no"
            v-model="render_profile_email"
            :fetch-suggestions="querySearchProfileFromAddr"
            @select="handleProfileSelection"
          >
            <template slot-scope="{ item }">
              <div>{{ item.email }}</div>
              <div class="desc">{{ item.description }}</div>
            </template>
          </el-autocomplete>
          <input type="hidden" v-model="render_profile_id" />
        </form-item>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="testSend" :disabled="disableInput">
        {{ $t('CampaignForm_TestSendDialog_Button_Send') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import FormItem from '@/common/components/form/FormItem'
import RestApi from '@/core/services/RestApi'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'TestSendDialog',
  components: { FormItem },
  mounted() {
    if (
      this.user &&
      this.user.email &&
      !this.recipient_emails.find(email => email === this.user.email)
    ) {
      this.recipient_emails.push(this.user.email)
    }
  },
  data() {
    return {
      render_profile_email: '',
      render_profile_id: '',
      recipient_emails: [],
      disableInput: false,
      savedOptions: []
    }
  },
  props: {
    data: {
      type: Object,
      default: {
        email_subject: '',
        email_from_address: '',
        email_from_name: '',
        email_html: ''
      }
    },
    dialogVisible: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    options() {
      this.savedOptions = [
        ...new Set([...(this.recipient_emails || []), ...this.savedOptions])
      ]
      return this.savedOptions
    },
    ...mapGetters(['user'])
  },
  methods: {
    testSend() {
      const emailDetails = {
        subject: this.data.email_subject,
        from_address: this.data.email_from_address,
        from_name: this.data.email_from_name,
        recipient_emails: this.recipient_emails,
        render_profile_id: this.render_profile_id || null,
        html: this.data.email_html
      }

      const projectId = this.$route.query.project_id
      this.disableInput = true
      RestApi.post(`projects/${projectId}/email-test-send`, emailDetails)
        .then(() => {
          this.disableInput = false
          this.close()
          this.$message({
            message: this.$t(
              'CampaignForm_TestSendDialog_Notification_Send_Successful'
            ),
            type: 'success'
          })
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
        .finally(() => (this.disableInput = false))
    },
    close() {
      if (!this.disableInput) {
        this.$emit('update:dialogVisible', false)
      }
    },
    querySearchFromAddr(queryString, cb) {
      axios
        .get(`/email/email-address/autocomplete`, {
          params: {
            project_id: this.$route.query.project_id,
            term: queryString
          }
        })
        .then(({ data }) => {
          cb(data)
        })
    },
    querySearchProfileFromAddr(queryString, cb) {
      RestApi.get(
        `/projects/${this.$route.query.project_id}/user-profiles?email=${queryString}`
      ).then(({ data }) => {
        const list = data.map(profile => {
          return {
            description: `${this.$t('CampaignsList_Field_Id')}: ${
              profile.id
                ? profile.id
                : this.$t('CampaignForm_Push_DefaultAction_None')
            }`,
            id: profile.id,
            email: profile.email || '(No email)'
          }
        })
        cb(list)
      })
    },
    handleProfileSelection(item) {
      this.render_profile_email = item.email
      this.render_profile_id = item.id
    },
    handleFromAddr(item) {
      this.data.email_from_address = item.value
      this.data.email_from_name = item.name
      this.data.email_reply_to_name = item.name
      this.data.email_reply_to_address = item.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/content/channels/TestSendDialog.vue